import React from 'react';
import Grid from '@mui/material/Grid';
import {
  StyledBlock,
  StyledChildBlock,
  StyledSingleBlock,
} from 'pages/AdministrationPage/styles';
import { Link } from 'react-router-dom';
import { ERouteLinks } from 'models/route';
import { colors } from 'theme/colors';
import Icon from 'components/atoms/Icon/Icon';
import { EIconTypes } from 'constants/Icons';
import { Typography } from '@mui/material';

export interface IElements {
  title: string;
  url: ERouteLinks;
}

interface IElementsComponent {
  title?: string;
  iconType: EIconTypes;
  elements: IElements[];
}

const ElementsComponent = ({ title, iconType, elements }: IElementsComponent) => {
  if (elements.length === 1) {
    return (
      <Grid size={{ xs: 12 }}>
        <Link to={elements[0].url} style={{ color: colors.black, textDecoration: 'none' }}>
          <StyledSingleBlock container size={{ xs: 12 }}>
            <div>
              <Icon type={iconType} fontSize={28} color={colors.primary900} />
              <Typography variant="h5" sx={{ mt: "2px" }}>
                {elements[0].title}
              </Typography>
            </div>
            <Icon type={EIconTypes.right} fontSize={24} color={colors.primary900} />
          </StyledSingleBlock>
        </Link>
      </Grid>
    );
  }
  return (
    <StyledBlock container size={{ xs: 12 }}>
      <Grid container size={{ xs: 12 }} sx={{ gap: 2 }}>
        <Icon type={iconType} fontSize={28} color={colors.primary900} />
        <Typography variant="h5" sx={{ mt: "2px" }}>
          {title}
        </Typography>
      </Grid>
      <Grid container size={{ xs: 12 }} columnSpacing={2} sx={{ rowGap: 0.5 }}>
        {elements.map((item: IElements) => (
          <Grid size={{ xs: 12, md: 6 }}>
            <Link to={item.url} style={{ color: colors.black, textDecoration: 'none' }}>
              <StyledChildBlock>
                <Typography variant="body2">{item.title}</Typography>
                <Icon type={EIconTypes.right} fontSize={24} color={colors.primary900} />
              </StyledChildBlock>
            </Link>
          </Grid>
        ))}
      </Grid>
    </StyledBlock>
  );
};

export default ElementsComponent;
